import React from 'react';
import { useTranslation } from 'react-i18next';
import SEO, { createWebPageSchema, createBreadcrumbSchema } from '../components/SEO.tsx';
import MemeCard from '../components/memes/MemeCard.tsx';
import AdSense, { AnchorAd } from '../components/AdSense.tsx';
import { memeData } from '../data/memeData.ts';

const Memes: React.FC = () => {
  const { t, i18n } = useTranslation();
  const isKorean = i18n.language === 'ko';

  const structuredData = [
    createWebPageSchema({
      title: `${t('pageTitle.memes')} | ${t('companyName')}`,
      description: isKorean
        ? '개발자라면 공감할 프로그래밍 밈으로 코딩의 즐거움을 느껴보세요.'
        : 'Discover the joy of coding through programming memes every developer can relate to.',
      url: '/memes'
    }),
    createBreadcrumbSchema([
      { name: isKorean ? '홈' : 'Home', url: '/' },
      { name: t('pageTitle.memes'), url: '/memes' }
    ])
  ];

  return (
    <div className="min-h-screen bg-background-primary pt-16">
      <SEO
        title={t('pageTitle.memes')}
        description={isKorean
          ? '개발자라면 공감할 프로그래밍 밈으로 코딩의 즐거움을 느껴보세요.'
          : 'Discover the joy of coding through programming memes every developer can relate to.'}
        keywords={['programming memes', 'developer memes', 'coding humor', '프로그래밍 밈', '개발자 밈', '코딩']}
        canonicalUrl="/memes"
        ogImage="/images/og-memes.jpg"
        ogImageAlt={`${t('companyName')} ${t('pageTitle.memes')}`}
        structuredData={structuredData}
      />

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        {/* Header */}
        <div className="text-center mb-8 sm:mb-12">
          <h1 className="text-3xl sm:text-4xl md:text-5xl font-bold text-text-primary mb-3 sm:mb-4">
            {t('memes.title')} <span className="text-green-600">{t('memes.titleHighlight')}</span>
          </h1>
          <p className="text-base sm:text-xl text-text-secondary max-w-2xl mx-auto px-2">
            {t('memes.subtitle')}
          </p>
        </div>

        {/* Memes Grid - Mobile: List / Desktop: Grid */}
        <div className="space-y-3 md:space-y-0 md:grid md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 md:gap-6 mb-16">
          {memeData.map((meme) => (
            <MemeCard key={meme.id} meme={meme} />
          ))}
        </div>

        {/* AdSense - Bottom of page */}
        <div className="mt-12 mb-8">
          <AdSense
            adSlot="9767464719"
            adFormat="auto"
            className="min-h-[250px]"
          />
        </div>
      </div>

      {/* Anchor Ad - Sticky Bottom */}
      <AnchorAd adSlot="7117250640" />
    </div>
  );
};

export default Memes;
